import React from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout";
import { SERVICES } from "../../data/staticData";
import { ArrowUpRight } from "lucide-react";

export default function DashboardServices() {
  return (
    <DashboardLayout>
      <div>
        <div className="eyebrow mb-2">Catalog</div>
        <h1 className="font-display text-4xl font-bold tracking-tight">Order a service</h1>
        <p className="text-inkSoft mt-1">Browse the full catalog and place an order in under three minutes.</p>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="dashboard-services-grid">
        {SERVICES.map((s) => {
          const Icon = s.icon;
          return (
            <Link
              key={s.slug}
              to={`/dashboard/services/${s.slug}`}
              className="card-soft p-6 group flex flex-col"
              data-testid={`dashboard-service-${s.slug}`}
            >
              <div className="flex items-center justify-between">
                <div className="h-11 w-11 rounded-xl bg-surfaceAlt grid place-items-center text-terra group-hover:bg-terra group-hover:text-white transition">
                  <Icon size={20} />
                </div>
                <ArrowUpRight size={16} className="text-inkSoft group-hover:text-terra transition" />
              </div>
              <h2 className="font-display text-lg font-semibold tracking-tight mt-5">{s.title}</h2>
              <p className="mt-2 text-sm text-inkSoft leading-relaxed line-clamp-3 flex-1">{s.short}</p>
              <div className="mt-5 pt-4 border-t border-line flex items-center justify-between">
                <span className="text-xs text-inkSoft">From</span>
                <span className="font-mono font-semibold">${s.starting_price}</span>
              </div>
            </Link>
          );
        })}
      </div>
    </DashboardLayout>
  );
}
